import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { StorageService } from '@core/services/storage/storage.service';
import { VersionComponent } from '../version/version.component';

enum RoleTypes {
  CONSUMER = 'CONSUMER',
  PROVIDER = 'PROVIDER',
  HD = 'HD ADMIN',
}

const CONSUMER_EMAIL = ['umbrella.org', 'acme.org'];
const PROVIDER_EMAIL = 'acme.org';
const HD_EMAIL = 'hypherdata.com';

@Component({
  selector: 'hd-demo-header',
  standalone: true,
  imports: [VersionComponent],
  templateUrl: './demo-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoHeaderComponent implements OnInit {
  protected userEmail = inject(StorageService).getUserEmail();
  protected userRoleSignal$$ = signal<string | null>(null);
  protected readonly RoleTypes = RoleTypes;

  ngOnInit() {
    this.userRoleSignal$$.set(this.getRole());
  }

  private getRole() {
    if (
      this.userEmail?.includes(CONSUMER_EMAIL[0]) ||
      this.userEmail?.includes(CONSUMER_EMAIL[1])
    ) {
      return RoleTypes.CONSUMER;
    }

    if (this.userEmail?.includes(PROVIDER_EMAIL)) {
      return RoleTypes.PROVIDER;
    }

    if (this.userEmail?.includes(HD_EMAIL)) {
      return RoleTypes.HD;
    }

    return null;
  }
}
